import { PosActionTypes, PosState } from './Types';

export const REGISTER_POS: PosActionTypes = 'REGISTER_POS';
export const GET_POS_HISTORIES: PosActionTypes = 'GET_POS_HISTORIES';
export const REFUND_POS: PosActionTypes = 'REFUND_POS';
export const ROW_CLICKED: PosActionTypes = 'ROW_CLICKED';
export const EMAIL_RECEIPT: PosActionTypes = 'EMAIL_RECEIPT';
export const CREATE_PREDEFINED_ITEM: PosActionTypes = 'CREATE_PREDEFINED_ITEM';
export const UPDATE_PREDEFINED_ITEM: PosActionTypes = 'UPDATE_PREDEFINED_ITEM';
export const DELETE_PREDEFINED_ITEM: PosActionTypes = 'DELETE_PREDEFINED_ITEM';
export const GET_PREDEFINED_ITEMS: PosActionTypes = 'GET_PREDEFINED_ITEMS';

export const INITIAL_STATE: PosState = {
  statusCode: 0,
  sale: {
    id: 0,
    receiptId: '',
    description: '',
    responseCode: '',
    cardType: '',
    amount: 0,
    total: 0,
    tax: 0,
    currency: 'CAD',
    message: '',
    complete: false,
    transDate: '',
    transTime: '',
    refundable: false,
    transactionType: '',
    maskedPan: '',
    paymentMethodType: 'CASH',
    name: ''
  },
  histories: [],
  predefinedItems: []
};


// WEBPACK FOOTER //
// ./src/pos/Constants.tsx